import { createTranslations } from '@npco/utils-translations'

export const bulletPointsCardTranslation = createTranslations({
  point1: 'Free express shipping',
  point2: 'Same-day dispatch',
  point3: 'Money-back guarantee',
  point4: 'Limited time only',
})
